






















import { CollectionItem } from '@/resource/collection-item/collection-item.model';
import { Component, Prop, Vue } from 'vue-property-decorator';
import PaperItemOption from './PaperItemOption.vue';
import PaperItemRearrange from './PaperItemRearrange.vue';

@Component({
  components: { PaperItemOption, PaperItemRearrange },
})
export default class PaperItemWrapper extends Vue {
  @Prop({ required: true })
  paperItem: CollectionItem;

  @Prop({ required: true })
  showRearrange: boolean;

  @Prop({ required: true })
  isObjective: boolean;

  @Prop({ default: 1 })
  subjectiveTitleIndex: number;

  @Prop({ required: true })
  index: number;

  @Prop({ required: true })
  numberOrder: number;

  @Prop({ required: true })
  totalPaperItems: number;

  showPaperItemOption = false;

  togglePaperItemOption(show: boolean) {
    this.showPaperItemOption = show;
  }
}
